import { render, staticRenderFns } from "./ProductItemsViewTable.vue?vue&type=template&id=17a007bb&"
import script from "./ProductItemsViewTable.vue?vue&type=script&lang=js&"
export * from "./ProductItemsViewTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemsViewTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports